import { applicantFormSections } from "@data/default/applicantFormFields";
import { adminFormSections } from "@data/default/adminFormFields";
import { scholarshipFormSections } from "@data/default/scholarshipFormFields";
import { externalScholarshipFormFields } from "@data/default/externalScholarshipFormFields";
import academicProgrammesRecords from "@data/default/academicProgrammesRecords";
import {
  allUndergraduateProgrammes,
  allPostgraduateProgrammes,
  allAcademicProgrammes,
} from "@data/default/getAllAcademicProgrammes";

const exportDefaultData = {
  applicantFormSections,
  adminFormSections,
  academicProgrammesRecords,
  allUndergraduateProgrammes,
  allPostgraduateProgrammes,
  allAcademicProgrammes,
  scholarshipFormSections,
  externalScholarshipFormFields,
};

export default exportDefaultData;
